const commaListify = (elements, conjunction = "and") =>
  elements.length === 2 ? elements.join(` ${conjunction} `) : elements.join(", ").replace(/,(?=[^,]*$)/, `, ${conjunction} `);

export default commaListify;
